import { defineMessages } from 'react-intl'

export const articleMessages = defineMessages({
  article: {
    id: 'components.objects.article',
    defaultMessage: 'Article'
  },
  event: {
    id: 'components.objects.event',
    defaultMessage: 'Event'
  },
  competition: {
    id: 'components.objects.competition',
    defaultMessage: 'Competition'
  },
  author: {
    id: 'components.objects.article.author',
    defaultMessage: 'Author'
  },
  by: {
    id: 'components.objects.common.by',
    defaultMessage: 'by'
  }
})

export const manufacturerMessages = defineMessages({
  manufacturer: {
    id: 'components.objects.manufacturer',
    defaultMessage: 'Manufacturer'
  },
  productCategories: {
    id: 'components.objects.manufacturer.productCategories',
    defaultMessage: 'Product Categories'
  },
  availableProducts: {
    id: 'components.objects.manufacturer.availableProducts',
    defaultMessage: 'Available Products'
  },
  linkedProjects: {
    id: 'components.objects.manufacturer.linkedProjects',
    defaultMessage: 'Linked Projects'
  },
  bimObjects: {
    id: 'components.objects.manufacturer.bimObjects',
    defaultMessage: 'BIM Objects'
  }
})

export const projectMessages = defineMessages({
  project: {
    id: 'components.objects.project',
    defaultMessage: 'Project'
  },
  architects: {
    id: 'components.objects.project.architects',
    defaultMessage: 'Architects'
  },
  location: {
    id: 'components.objects.project.location',
    defaultMessage: 'Location'
  },
  categories: {
    id: 'components.objects.project.categories',
    defaultMessage: 'Categories'
  },
  companies: {
    id: 'components.objects.project.companies',
    defaultMessage: 'Manufacturers'
  }
})

export const productMessages = defineMessages({
  product: {
    id: 'components.objects.product',
    defaultMessage: 'Product'
  },
  manufacturer: {
    id: 'components.objects.product.manufacturer',
    defaultMessage: 'Manufacturer'
  },
  product_type: {
    id: 'components.objects.product.product_type',
    defaultMessage: 'Article Type'
  },
  use: {
    id: 'components.objects.product.use',
    defaultMessage: 'Use'
  },
  characteristics: {
    id: 'components.objects.product.characteristics',
    defaultMessage: 'Characteristics'
  },
  bimObjects: {
    id: 'components.objects.product.bimObjects',
    defaultMessage: 'BIM Objects'
  },
  location: {
    id: 'components.objects.product.location',
    defaultMessage: 'Location'
  },
  country: {
    id: 'components.objects.product.country',
    defaultMessage: 'Country/Region'
  }
})

export const professionalsMessages = defineMessages({
  projects: {
    id: 'components.objects.projects',
    defaultMessage: 'Projects'
  },
  project: {
    id: 'components.objects.project',
    defaultMessage: 'Project'
  }
})

export const widgetMessages = defineMessages({
  resultsForProducts: {
    id: 'components.objects.widget.resultsForProducts',
    defaultMessage: 'Products and BIM Files'
  },
  resultsForArticles: {
    id: 'components.objects.widget.resultsForArticles',
    defaultMessage: 'News and Articles'
  },
  resultsForProjects: {
    id: 'components.objects.widget.resultsForProjects',
    defaultMessage: 'Architecture Projects'
  },
  resultsForFolders: {
    id: 'components.objects.widget.resultsForFolders',
    defaultMessage: 'Folders'
  },
  productsSearch: {
    id: 'components.objects.widget.productsSearch',
    defaultMessage: 'Go to Products Search'
  },
  projectsSearch: {
    id: 'components.objects.widget.projectsSearch',
    defaultMessage: 'Go to Projects Search'
  },
  articlesSearch: {
    id: 'components.objects.widget.articlesSearch',
    defaultMessage: 'Go to Articles Search'
  },
  foldersSearch: {
    id: 'components.objects.widget.foldersSearch',
    defaultMessage: 'Go to Folders Search'
  },
  by: {
    id: 'components.objects.common.by',
    defaultMessage: 'by'
  },
  lastUpdate: {
    id: 'components.objects.widget.folder.lastUpdate',
    defaultMessage: 'Last Update'
  },
  tags: {
    id: 'components.objects.widget.tags',
    defaultMessage: 'Related Tags'
  },
  offices: {
    id: 'components.objects.widget.offices',
    defaultMessage: 'Related Architectural Offices'
  },
  professionals: {
    id: 'components.objects.widget.professionals',
    defaultMessage: 'Related Professionals'
  },
  companies: {
    id: 'components.objects.widget.companies',
    defaultMessage: 'Manufacturers'
  },
  viewAll: {
    id: 'components.objects.widget.viewAll',
    defaultMessage: 'View All'
  }
})

export const aggregationsMessages = defineMessages({
  resultsForProductsAndBimFiles: {
    id: 'components.objects.widget.resultsForProductsAndBimFiles',
    defaultMessage: 'Results for Products and BIM Files'
  }
})
